import { ReactNode } from "react";
import {
  UserIcon,
  PhoneIcon,
  CheckCircle2Icon,
  LoaderIcon,
  XCircleIcon,
  CirclePlus,
  BanIcon,
  Calendar,
  Loader2Icon,
  User,
  AppWindowIcon,
  MapPin,
  Receipt,
  Pen,
} from "lucide-react";

export const STATUS = ["pending", "approved", "rejected"] as const;

export const statusColor: Record<string, Record<"badge" | "dot", string>> = {
  approved: {
    badge:
      "text-[#10b981] bg-[#10b981]/10 border-[#10b981]/20 hover:bg-[#10b981]/10",
    dot: "bg-[#10b981]",
  },
  // web: {
  //   badge:
  //     "text-[#0ea5e9] bg-[#0ea5e9]/10 border-[#0ea5e9]/20 hover:bg-[#0ea5e9]/10",
  //   dot: "bg-[#0ea5e9]",
  // },
  rejected: {
    badge:
      "text-[#ec4899] bg-[#ec4899]/10 border-[#ec4899]/20 hover:bg-[#ec4899]/10",
    dot: "bg-[#ec4899]",
  },
  pending: {
    badge:
      "text-[#f97316] bg-[#f97316]/10 border-[#f97316]/20 hover:bg-[#f97316]/10",
    dot: "bg-[#f97316]",
  },
};

export const taxiStatusColor: Record<string, Record<"badge" | "dot", string>> = {
    NEW_ORDER: {
        badge: "text-blue-600 bg-blue-600/10 border-blue-600/20 hover:bg-blue-600/10",
        dot: "bg-blue-600",
    },
    ASSIGNMENT_PENDING: {
        badge: "text-yellow-600 bg-yellow-600/10 border-yellow-600/20 hover:bg-yellow-600/10",
        dot: "bg-yellow-600",
    },
    GOING_TO_PICKUP: {
        badge: "text-purple-600 bg-purple-600/10 border-purple-600/20 hover:bg-purple-600/10",
        dot: "bg-purple-600",
    },
    ASSIGNED: {
        badge: "text-indigo-600 bg-indigo-600/10 border-indigo-600/20 hover:bg-indigo-600/10",
        dot: "bg-indigo-600",
    },
    COMPLETION_REQUEST: {
        badge: "text-teal-600 bg-teal-600/10 border-teal-600/20 hover:bg-teal-600/10",
        dot: "bg-teal-600",
    },
    COMPLETED: {
        badge: "text-green-600 bg-green-600/10 border-green-600/20 hover:bg-green-600/10",
        dot: "bg-green-600",
    },
    REJECTED: {
        badge: "text-red-600 bg-red-600/10 border-red-600/20 hover:bg-red-600/10",
        dot: "bg-red-600",
    },
    CANCELLED: {
        badge: "text-gray-600 bg-gray-600/10 border-gray-600/20 hover:bg-gray-600/10",
        dot: "bg-gray-600",
    },
    ACCEPTED: {
        badge: "text-green-600 bg-green-600/10 border-green-600/20 hover:bg-green-600/10",
        dot: "bg-green-600",
    },
    RESCHEDULED: {
        badge: "text-yellow-600 bg-yellow-600/10 border-yellow-600/20 hover:bg-yellow-600/10",
        dot: "bg-yellow-600",
    },
    SCHEDULED: {
        badge: "text-cyan-600 bg-cyan-600/10 border-cyan-600/20 hover:bg-cyan-600/10",
        dot: "bg-cyan-600",
    },
    IN_PROGRESS: {
        badge: "text-orange-600 bg-orange-600/10 border-orange-600/20 hover:bg-orange-600/10",
        dot: "bg-orange-600",
    },
};

export const statusItems = [
  { label: "New Orders", status: "NEW_ORDER" },
  { label: "Approved", status: "ACCEPTED" },
  { label: "Assigned", status: "ASSIGNED" },
  { label: "In Process", status: "IN_PROGRESS" },
  { label: "Completed", status: "COMPLETED" },
  { label: "Rejected", status: "REJECTED" },
  { label: "Cancelled", status: "CANCELLED" },
];

export const taxiStatusItems: { label: string; status: string; display: boolean; icon?: any; color?: string}[] = [
  { label: "New Order", status: "NEW_ORDER", display: true, icon: CirclePlus, color: "text-gray-500 dark:text-gray-400" },
  { label: "Assigned", status: "ASSIGNED", display: true },
  { label: "Accepted", status: "ACCEPTED", display: true, icon: CheckCircle2Icon, color: "text-green-500 dark:text-green-400" },
  { label: "To Pickup", status: "GOING_TO_PICKUP", display: true, icon: MapPin, color: "text-gray-500 dark:text-gray-400" },
  { label: "In Progress", status: "IN_PROGRESS", display: true, icon: LoaderIcon, color: "text-gray-500 dark:text-gray-400" },
  { label: "Completion Request", status: "COMPLETION_REQUEST", display: false },
  { label: "Completed", status: "COMPLETED", display: true, icon: CheckCircle2Icon, color: "text-green-500 dark:text-green-400" },
  { label: "Rejected", status: "REJECTED", display: true, icon: XCircleIcon, color: "text-red-500 dark:text-red-400" },
  { label: "Cancelled", status: "CANCELLED", display: true, icon: BanIcon, color: "text-red-500 dark:text-red-400" },
  { label: "Rescheduled", status: "RESCHEDULED", display: false },
  { label: "Scheduled", status: "SCHEDULED", display: false },
  { label: "Assignment Pending", status: "ASSIGNMENT_PENDING", display: false },
];
